import { ListGroup } from 'reactstrap'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useLocation, useHistory } from 'react-router-dom'
import ConversationHeader from './ConversationHeader'
import { useEffect } from 'react'
import { setConversations } from 'store/Chats/actions'
import { archiveConversations } from 'store/Chats/actions'

export default function Conversations({ conversations }) {
  const loadingConversations = useSelector(
    (store) => store.chat.loadingConversations
  )

  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    if (
      conversations?.length > 0 &&
      location?.pathname?.split('/').length === 2
    ) {
      history.push(`/messages/${conversations[0].id}`)
    }
  }, [conversations, history, location.pathname])

  useEffect(() => {
    // Fetch immediately on mount
    dispatch(setConversations())

    // Then continue polling every 3 seconds
    const intervalId = setInterval(() => {
      dispatch(setConversations())
    }, 3000)

    return () => clearInterval(intervalId)
  }, [dispatch])

  useEffect(() => {
    dispatch(archiveConversations())
  }, [dispatch])

  return (
    <ListGroup flush>
      {conversations?.map((conversation) => {
        const isActive = location.pathname === `/messages/${conversation.id}`
        return (
          <Link key={conversation.id} to={`/messages/${conversation.id}`}>
            <ConversationHeader
              conversation={conversation}
              isActive={isActive}
            />
          </Link>
        )
      })}
      {loadingConversations && conversations.length === 0 && (
        <div>Loading conversations...</div>
      )}
      {conversations.length === 0 && !loadingConversations && (
        <div>No conversations found.</div>
      )}
    </ListGroup>
  )
}
